exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".provider-panel--3paJ7_spN8g28X_QLIT2w0 {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width: 100%;\n}\n", ""]);

// exports
exports.locals = {
	"practiceName": "provider-panel--3paJ7_spN8g28X_QLIT2w0",
	"practiceName": "provider-panel--3paJ7_spN8g28X_QLIT2w0"
};